import React from "react"
import { FaqSection } from "./types"
import { TwRichTextField } from "../../../root/punks/core/fields/RichTextField"
import CustomChip from "../../atoms/CustomChip"

interface Props {
  sections: FaqSection[]
  selected: FaqSection | undefined
  onSelected: (category: FaqSection) => void
}

const FaqPanelChips = ({ sections, selected, onSelected }: Props) => {
  const isSelected = (category: FaqSection) => selected?.id === category.id

  return (
    <div className="flex py-2 -mx-4 overflow-x-auto sm:mx-0">
      {sections.map((x) => (
        <div className="mx-2 my-2" key={x.id}>
          <CustomChip
            variant={isSelected(x) ? "default" : "outlined"}
            onClick={() => onSelected(x)}
            label={<TwRichTextField value={x.title} />}
          />
        </div>
      ))}
    </div>
  )
}

export default FaqPanelChips
